import window from 'window-or-global';
import { getRte } from '../../facades/editor';
import { isDarkFeatureEnabled } from '../utils/dark-features-query-selector';
import { bind, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

/**
 * This tinyMCE plugin wraps block elements,which are inside a table cell, into a DIV
 * So that when user resize a column to fix mode, these elements don't overlap a cell
 */
function TableContentWrapper() {
	const blockElements = ['img:not(.editor-inline-macro, .emoticon)'];
	const blockMacros = ['.wysiwyg-macro'];
	const inlineElements = [
		'time.non-editable',
		'.editor-inline-macro',
		"a.confluence-link[data-linked-resource-type='userinfo']",
	];
	const elementsToWrap = blockElements.concat(inlineElements).concat(blockMacros).join(',');
	const contentWrapper = "<div class='content-wrapper'>";

	return {
		init(ed) {
			/**
			 * CONFDEV-38889
			 */
			function wrapAll() {
				const cssMarker = 'wrapped';
				$(ed.dom.select(`table.confluenceTable:not(.${cssMarker})`)).each((i, table) => {
					//add CSS class to mark this table as processed
					$(table)
						.addClass(cssMarker)
						.find('> tbody > tr > th, > tbody > tr > td, > thead > tr > th')
						.each((i, cell) => {
							const $cell = $(cell);
							if (!$cell.find('> .content-wrapper').length && $cell.find(elementsToWrap).length) {
								$cell.wrapInner(contentWrapper);
							}
						});
				});
			}

			bind('rte-ready', wrapAll);
			//CONFDEV-55148
			ed.on('Remove', () => {
				unbind('rte-ready', wrapAll);
			});

			ed.on('Change', () => {
				const mceSelection = ed.selection;

				function mergeManyWrappers($wrappers) {
					for (let i = 0; i < $wrappers.length; i++) {
						if (!$wrappers.eq(i).find('> p, > table, > ul, > ol').length) {
							/**
							 * <p> is the fundamental element to seperate lines and wrap inline element (e.g <img>, <span>)
							 * missing it will lead to unexpected behavior of tinyMCE
							 */
							$wrappers.eq(i).wrapInner('<p/>');
						}
						//combine content of all other wrappers to the first one
						if (i > 0) {
							$wrappers.eq(0).append($wrappers.eq(i).children());
							$wrappers.eq(i).remove();
						}
					}
				}

				function fixCursorPosition($currentNode) {
					const range = mceSelection.getRng();
					/**
					 * CONFDEV-41716
					 * if current node is TR, mceSelection.getBookmark() will append bookmark <span> directly to TR
					 * which will place cursor to wrong position after restore bookmark
					 * So need to move selection to child element of the TR
					 */
					if ($currentNode.is('tr') && $(range.startContainer).is('tr') && range.collapsed) {
						const $directCell = $currentNode.find('>td, >th').first();
						//if cell only has text inside, we need "firstChild" to get TextNode
						const startNode =
							$directCell.find(':first-child:not(.content-wrapper)')[0] ||
							$directCell[0].firstChild;
						range.setStart(startNode, 0);
						range.setEnd(startNode, 0);

						mceSelection.setRng(range);
					}
				}

				function saveBookmark() {
					return mceSelection.getBookmark();
				}

				function restoreBookmark(bookmark) {
					mceSelection.moveToBookmark(bookmark);
					/**
					 * we dont want to touch code of 'confluence-editor/atlassian-editor-bookmark-manager'
					 * we storeBookmark again, so that other module can restoreBookmark correctly
					 */
					getRte().BookmarkManager.storeBookmark();
				}

				const node = mceSelection.getNode();
				const $node = $(node);
				//dont wrap anything inside nested table
				if (
					node &&
					$node.closest('table.confluenceTable').not('table.confluenceTable table.confluenceTable')
						.length
				) {
					fixCursorPosition($node);

					const $currentCell = $node.closest(
						'table.confluenceTable > tbody > tr > th, table.confluenceTable > tbody > tr > td, table.confluenceTable > thead > tr > th',
					);
					let bookmark;

					if ($currentCell.find(elementsToWrap).length) {
						const $directWrapper = $currentCell.find('> .content-wrapper');
						if (!$directWrapper.length) {
							if ($currentCell.find('> p').length) {
								bookmark = saveBookmark($node);
								$currentCell.wrapInner(contentWrapper);
								restoreBookmark(bookmark);
							} else {
								bookmark = saveBookmark($node);
								/**
								 * <p> is the fundamental element to seperate lines and wrap inline element (e.g <img>, <span>)
								 * missing it will lead to unexpected behavior of tinyMCE
								 */
								$currentCell.wrapInner('<p/>').wrapInner(contentWrapper);
								restoreBookmark(bookmark);
							}
						} else {
							bookmark = saveBookmark($node);
							mergeManyWrappers($directWrapper);
							restoreBookmark(bookmark);
						}
					}
				}

				// Remove empty wrapper
				$(ed.getWin().document).find('.content-wrapper:empty').remove();
			});
		},

		getInfo() {
			return {
				longname: 'Table Content Wrapper Plugin',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: '1.0',
			};
		},
	};
}

export default () => {
	if (isDarkFeatureEnabled('confluence.table.resizable')) {
		window.tinymce.create('tinymce.plugins.TableContentWrapperPlugin', TableContentWrapper());
		window.tinymce.PluginManager.add(
			'tableContentWrapper',
			window.tinymce.plugins.TableContentWrapperPlugin,
		);
	}
};
